// extracted by mini-css-extract-plugin
export default {"tableData":"SupportingDocument_tableData__jWIqB","docHeading":"SupportingDocument_docHeading__qIRyj"};